
import React, { useState, useCallback } from 'react';
import { Employee, AttendanceMethod, AttendanceStatus } from '../app/types';
import CameraView from './CameraView';

interface AttendanceModalProps {
  employee: Employee;
  onClose: () => void;  
  email:string;
  onReload: () => void;
}

type ModalView = 'options' | 'camera' | 'code';

const CloseIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>;
const CameraIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor"><path d="M2 6a2 2 0 012-2h12a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm4 5a3 3 0 106 0 3 3 0 00-6 0z" /><path d="M2 6a2 2 0 012-2h12a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm4 5a3 3 0 106 0 3 3 0 00-6 0z" /></svg>;
const CodeIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" /></svg>;
const BackArrowIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" /></svg>;


const AttendanceModal: React.FC<AttendanceModalProps> = ({ employee, onClose, email, onReload }) => {
  const [view, setView] = useState<ModalView>('camera');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
    
  const handleCodeSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (code.match(/^\d{6}$/)) {
      setError('');
      //onMarkAttendance(employee.Id, AttendanceMethod.CODE);
    } else {
      setError('El código debe tener 6 dígitos.');
    }
  };

  const renderContent = () => {
    // if (employee.status === AttendanceStatus.PRESENT) {
    //   return (
    //     <div className="p-6 flex flex-col items-center text-center">
    //         <img src={employee.avatarUrl} alt={employee.name} className="w-24 h-24 rounded-full object-cover border-4 border-secondary-container dark:border-dark-secondary-container" />
    //         <h2 className="text-2xl font-medium mt-4 text-on-surface dark:text-dark-on-surface">{employee.name}</h2>
    //         <p className="text-on-surface-variant dark:text-dark-on-surface-variant">{employee.role}</p>
    //         <p className="mt-6 text-center text-on-surface-variant dark:text-dark-on-surface-variant">¿Confirmas tu hora de salida?</p>
    //         <div className="mt-6 w-full flex flex-col gap-3">
    //             <button 
    //                 onClick={() => onMarkCheckout(employee.id)} 
    //                 className="w-full flex items-center justify-center bg-secondary dark:bg-dark-secondary text-on-secondary dark:text-dark-on-secondary font-bold py-3 px-4 rounded-full hover:shadow-lg transition-shadow">
    //                 <DoorOutIcon /> Confirmar Salida
    //             </button>
    //         </div>
    //     </div>
    //   );
    // }

    switch (view) {
      case 'camera':
        return <CameraView employee={employee}  onBack={onClose} email={email} onReload={onReload} />;
      case 'code':
        return (
          <div className="p-6 text-center">
            <button onClick={() => setView('options')} className="absolute top-4 left-4 flex items-center text-primary dark:text-dark-primary font-medium p-2 rounded-full hover:bg-primary/10 dark:hover:bg-dark-primary/10">
              <BackArrowIcon /> Volver
            </button>
            <h3 className="text-lg font-semibold mb-2 text-on-surface dark:text-dark-on-surface">Ingresar Código</h3>
            <p className="text-sm text-on-surface-variant dark:text-dark-on-surface-variant mb-6">Introduce tu código de 6 dígitos para registrar tu asistencia.</p>
            <form onSubmit={handleCodeSubmit}>
              <input
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                maxLength={6}
                className="w-full max-w-xs text-center text-3xl tracking-[.5em] bg-surface-container dark:bg-dark-surface-container border-b-2 border-outline dark:border-dark-outline focus:border-primary dark:focus:border-dark-primary rounded-t-md p-3 outline-none transition-colors"
                placeholder="------"
              />
              {error && <p className="text-error dark:text-dark-error text-sm mt-2">{error}</p>}
              <button type="submit" className="mt-6 w-full max-w-xs bg-primary dark:bg-dark-primary hover:shadow-lg text-on-primary dark:text-dark-on-primary font-bold py-3 px-4 rounded-full transition-shadow">
                Confirmar Asistencia
              </button>
            </form>
          </div>
        );
      case 'options':
      default:
        return (
          <div className="p-6 flex flex-col items-center text-center">
            <img src={`https://makosclock.com/ftpmakos/${employee.IdAttendance}.jpg`} 
              onError={(e) => {
                e.currentTarget.src = "../../images/user.png";
              }}   
              alt={employee.Name} 
              className="w-24 h-24 rounded-full object-cover border-4 border-primary-container dark:border-dark-primary-container" 
            />
            <h2 className="text-2xl font-medium mt-4 text-on-surface dark:text-dark-on-surface">{employee.Name}</h2>
            <p className="text-on-surface-variant dark:text-dark-on-surface-variant">{employee.AreaName}</p>            
            <div className="mt-6 w-full flex flex-col sm:flex-row gap-3">
              <button onClick={() => setView('camera')} className="w-full flex items-center justify-center bg-primary dark:bg-dark-primary text-on-primary dark:text-dark-on-primary font-bold py-3 px-4 rounded-full hover:shadow-lg transition-shadow">
                <CameraIcon /> Tomar Foto
              </button>
              {/* <button onClick={() => setView('code')} className="w-full flex items-center justify-center bg-secondary-container dark:bg-dark-secondary-container text-on-secondary-container dark:text-dark-on-secondary-container font-bold py-3 px-4 rounded-full hover:bg-primary/10 transition-colors">
                <CodeIcon /> Ingresar Código
              </button> */}
            </div>
          </div>
        );
    }
  };

  return (
    <div className="fixed inset-0 bg-scrim/30 dark:bg-scrim/50 z-40 flex items-center justify-center p-4 animate-fade-in" onClick={onClose}>
      <div className="relative bg-surface-container-high dark:bg-dark-surface-container-high text-on-surface dark:text-dark-on-surface rounded-3xl shadow-2xl w-full max-w-md m-4 transform animate-scale-in" onClick={e => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 text-on-surface-variant dark:text-dark-on-surface-variant hover:bg-error/10 dark:hover:bg-dark-error/10 p-2 rounded-full transition-colors">
          <CloseIcon />
        </button>
        {renderContent()}
      </div>
      <style>{`
        @keyframes fade-in { from { opacity: 0; } to { opacity: 1; } }
        .animate-fade-in { animation: fade-in 0.3s ease-out forwards; }
        @keyframes scale-in { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
        .animate-scale-in { animation: scale-in 0.3s ease-out forwards; }
      `}</style>
    </div>
  );
};

export default AttendanceModal;